import getPermissions from "./utils/getPermissions";
import omitEmpty from "./utils/omitEmpty";
export default {
    get: function (token) {
        var categories = getPermissions(token, "deals", ["categories"], ["read"]);
        var tags = getPermissions(token, "deals", ["tags"], ["read"]);
        var redemptions = getPermissions(token, "deals", ["redemptions"], ["read", "create"]);
        var favourites = getPermissions(token, "deals", ["favourites"], ["read", "create", "delete"]);
        /** @description: Hide Perks GO / location lanes as corona-virus 27/3/2020 */
        // const perksGo =
        //   getPermissions(token, "deals", ["deals"], ["read"], "canViewCardlink") &&
        //   getPermissions(token, "fidel", ["cards"], ["read", "create"])
        var permission = {
            categories: categories,
            tags: tags,
            redemptions: redemptions,
            favourites: favourites,
            perksGo: false
        };
        return omitEmpty(permission);
    }
};
